import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var InboxApi = /** @class */ (function () {
    function InboxApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    InboxApi.initialize = function (basePath, fetchApi) {
        if (!InboxApi.instance) {
            InboxApi.instance = new InboxApi(basePath, fetchApi);
        }
        return InboxApi.instance;
    };
    InboxApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1InboxApi(new Configuration(config));
    };
    return InboxApi;
}());
export { InboxApi };
